import {Hotkey, IconButton} from '@wandb/components';
import React from 'react';

import {hotkeyString} from '../util/hotkeys';

export const ToggleMinimizeRunSelectorButton = ({
  variant,
  toMinimize,
  onToggle,
}: {
  variant: 'secondary' | 'primary' | 'destructive' | 'ghost';
  toMinimize: boolean;
  onToggle: () => void;
}) => {
  return (
    <IconButton
      aria-label={toMinimize ? 'Minimize run selector' : 'Reveal run selector'}
      icon={toMinimize ? 'expand-left' : 'expand-right'}
      variant={variant}
      onPress={onToggle}
      tooltip={{
        children: (
          <>
            {toMinimize ? 'Minimize' : 'Reveal'} run selector
            <Hotkey
              ml={4}
              name="Toggle minimize run selector"
              keys={hotkeyString('toggleMinimizeRunSelector')}
            />
          </>
        ),
      }}
    />
  );
};
